import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, createTextVNode as _createTextVNode, normalizeStyle as _normalizeStyle, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "booking-view accommodation" }
const _hoisted_2 = ["title"]
const _hoisted_3 = ["innerHTML"]
const _hoisted_4 = { key: 0 }
const _hoisted_5 = { key: 0 }
const _hoisted_6 = ["id", "checked", "onInput"]
const _hoisted_7 = ["for"]
const _hoisted_8 = { class: "image" }
const _hoisted_9 = ["src"]
const _hoisted_10 = {
  key: 1,
  src: "/public/assets/img/LetsDoPlaceholder.jpg",
  alt: "",
  loading: "lazy",
  width: "540",
  height: "360"
}
const _hoisted_11 = { class: "label-content" }
const _hoisted_12 = { class: "link" }
const _hoisted_13 = ["onClick"]
const _hoisted_14 = {
  key: 0,
  class: "tags"
}
const _hoisted_15 = { class: "space-wrapper" }
const _hoisted_16 = {
  key: 1,
  class: "dl-icon"
}
const _hoisted_17 = ["innerHTML"]
const _hoisted_18 = {
  key: 3,
  class: "dl-icon nested"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!
  const _component_EasyDrop = _resolveComponent("EasyDrop")!
  const _component_EasyImageSlider = _resolveComponent("EasyImageSlider")!
  const _component_EasyModal = _resolveComponent("EasyModal")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("section", _hoisted_1, [
      _createElementVNode("div", null, [
        _createElementVNode("header", null, [
          _createElementVNode("h2", null, _toDisplayString(_ctx.pageTexts['hotelPageHotelRoomStepHeadline']), 1),
          _createElementVNode("div", null, [
            (_ctx.roomIndex === 0)
              ? (_openBlock(), _createBlock(_component_router_link, {
                  key: 0,
                  class: "back-btn",
                  title: _ctx.pageTexts['hotelPageNavigationButtonPrevious'],
                  to: { name: 'hotel', query: _ctx.query }
                }, null, 8, ["title", "to"]))
              : (_openBlock(), _createElementBlock("button", {
                  key: 1,
                  type: "button",
                  class: "back-btn",
                  title: _ctx.pageTexts['hotelPageNavigationButtonPrevious'],
                  onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.changeIndex(false)))
                }, null, 8, _hoisted_2)),
            (_ctx.pageTexts['hotelPageHotelRoomStepInfoPopup'])
              ? (_openBlock(), _createBlock(_component_EasyDrop, {
                  key: 2,
                  dropdownType: 'tooltip',
                  position: 'right'
                }, {
                  content: _withCtx(() => [
                    _createElementVNode("div", {
                      class: "rte",
                      innerHTML: _ctx.pageTexts['hotelPageHotelRoomStepInfoPopup']
                    }, null, 8, _hoisted_3)
                  ]),
                  _: 1
                }))
              : _createCommentVNode("", true)
          ])
        ]),
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.searchBookingOverview.paxRooms, (paxRoom, index) => {
          return (_openBlock(), _createElementBlock(_Fragment, { key: index }, [
            (index === _ctx.roomIndex)
              ? (_openBlock(), _createElementBlock("fieldset", _hoisted_4, [
                  (_ctx.searchBookingOverview.paxRooms.length > 1)
                    ? (_openBlock(), _createElementBlock("legend", _hoisted_5, [
                        _createElementVNode("strong", null, _toDisplayString(_ctx.pageTexts['hotelPageGeneralRoom']) + " " + _toDisplayString(index + 1), 1),
                        _createTextVNode(" • " + _toDisplayString(paxRoom.searchRoom.adults.length) + " " + _toDisplayString(_ctx.adultSinglePlural(paxRoom.searchRoom.adults.length)), 1),
                        (paxRoom.searchRoom.children.length)
                          ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                              _createTextVNode(" • " + _toDisplayString(paxRoom.searchRoom.children.length) + " " + _toDisplayString(_ctx.childSinglePlural(paxRoom.searchRoom.children.length)), 1)
                            ], 64))
                          : _createCommentVNode("", true)
                      ]))
                    : _createCommentVNode("", true),
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(paxRoom.rooms, (room, roomOptionIndex) => {
                    return (_openBlock(), _createElementBlock("div", {
                      class: "option-image",
                      key: roomOptionIndex
                    }, [
                      _createElementVNode("input", {
                        id: 'room' + index + roomOptionIndex,
                        type: "checkbox",
                        name: "hotelRooms",
                        checked: 
              room.hotelRoomKey ===
              _ctx.searchBookingOverview.bookingSelection.hotelRooms[index].hotelRoomKey
            ,
                        onInput: ($event: any) => (_ctx.updateRoom($event, room, index))
                      }, null, 40, _hoisted_6),
                      _createElementVNode("label", {
                        for: 'room' + index + roomOptionIndex
                      }, [
                        _createElementVNode("span", _hoisted_8, [
                          _createElementVNode("picture", null, [
                            (room.image)
                              ? (_openBlock(), _createElementBlock("img", {
                                  key: 0,
                                  src: room.image,
                                  alt: "",
                                  loading: "lazy",
                                  width: "540",
                                  height: "360"
                                }, null, 8, _hoisted_9))
                              : (_openBlock(), _createElementBlock("img", _hoisted_10))
                          ])
                        ]),
                        _createElementVNode("span", _hoisted_11, [
                          _createElementVNode("span", null, [
                            _createElementVNode("strong", null, _toDisplayString(room.name), 1),
                            _createElementVNode("small", null, _toDisplayString(room.shortDescription), 1),
                            _createElementVNode("span", _hoisted_12, [
                              _createElementVNode("a", {
                                onClick: ($event: any) => (_ctx.openModal($event, room))
                              }, _toDisplayString(_ctx.pageTexts['hotelPageHotelRoomStepLabelSeeDetails']), 9, _hoisted_13)
                            ])
                          ])
                        ]),
                        (room.additionalPrice > 0)
                          ? (_openBlock(), _createElementBlock("span", _hoisted_14, "+ " + _toDisplayString(room.additionalPrice.toLocaleString(_ctx.localeStrings.longName)) + " " + _toDisplayString(room.currency), 1))
                          : _createCommentVNode("", true)
                      ], 8, _hoisted_7)
                    ]))
                  }), 128))
                ]))
              : _createCommentVNode("", true)
          ], 64))
        }), 128)),
        _createElementVNode("div", _hoisted_15, [
          (_ctx.roomIndex >= _ctx.searchBookingOverview.paxRooms.length - 1)
            ? (_openBlock(), _createBlock(_component_router_link, {
                key: 0,
                class: "btn-primary",
                to: { name: 'pension', query: _ctx.query }
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.pageTexts['hotelPageNavigationButtonNext']), 1)
                ]),
                _: 1
              }, 8, ["to"]))
            : (_openBlock(), _createElementBlock("button", {
                key: 1,
                type: "button",
                class: "btn-primary",
                onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.changeIndex(true)))
              }, _toDisplayString(_ctx.pageTexts['hotelPageNavigationButtonNext']), 1)),
          (_ctx.roomIndex === 0)
            ? (_openBlock(), _createBlock(_component_router_link, {
                key: 2,
                class: "prev",
                to: { name: 'hotel', query: _ctx.query }
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.pageTexts['hotelPageNavigationButtonPrevious']), 1)
                ]),
                _: 1
              }, 8, ["to"]))
            : (_openBlock(), _createElementBlock("button", {
                key: 3,
                type: "button",
                class: "prev",
                onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.changeIndex(false)))
              }, _toDisplayString(_ctx.pageTexts['hotelPageNavigationButtonPrevious']), 1))
        ])
      ])
    ]),
    _createVNode(_component_EasyModal, {
      isShowModal: _ctx.showModal,
      pageTexts: _ctx.pageTexts,
      customClasses: 'details',
      onCloseModal: _ctx.closeModal
    }, {
      headerText: _withCtx(() => [
        _createTextVNode(_toDisplayString(_ctx.selectedRoom?.name), 1)
      ]),
      content: _withCtx(() => [
        (_ctx.selectedRoom?.images.length)
          ? (_openBlock(), _createBlock(_component_EasyImageSlider, {
              key: 0,
              images: _ctx.selectedRoom?.images
            }, null, 8, ["images"]))
          : _createCommentVNode("", true),
        (_ctx.selectedRoom?.uspItems.length)
          ? (_openBlock(), _createElementBlock("dl", _hoisted_16, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.selectedRoom.uspItems, (usp, index) => {
                return (_openBlock(), _createElementBlock("div", {
                  key: index,
                  style: _normalizeStyle({ '--icon-url': 'url(' + usp.iconUrl + ')' })
                }, [
                  _createElementVNode("dt", null, _toDisplayString(usp.label), 1),
                  _createElementVNode("dd", null, _toDisplayString(usp.value), 1)
                ], 4))
              }), 128))
            ]))
          : _createCommentVNode("", true),
        (_ctx.selectedRoom?.description)
          ? (_openBlock(), _createElementBlock("div", {
              key: 2,
              class: "rte",
              innerHTML: _ctx.selectedRoom?.description
            }, null, 8, _hoisted_17))
          : _createCommentVNode("", true),
        _createElementVNode("h3", null, _toDisplayString(_ctx.pageTexts['hotelPageHotelRoomStepLabelRoomFacilities']), 1),
        (_ctx.selectedRoom?.facilityGroups.length)
          ? (_openBlock(), _createElementBlock("dl", _hoisted_18, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.selectedRoom.facilityGroups, (facilityGroup, index) => {
                return (_openBlock(), _createElementBlock("div", {
                  key: index,
                  style: _normalizeStyle({ '--icon-url': 'url(' + facilityGroup.iconUrl + ')' })
                }, [
                  _createElementVNode("dt", null, _toDisplayString(facilityGroup.title), 1),
                  _createElementVNode("dd", null, [
                    _createElementVNode("ul", null, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(facilityGroup.facilities, (facility, index) => {
                        return (_openBlock(), _createElementBlock("li", { key: index }, _toDisplayString(facility.title) + " : " + _toDisplayString(facility.value), 1))
                      }), 128))
                    ])
                  ])
                ], 4))
              }), 128))
            ]))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }, 8, ["isShowModal", "pageTexts", "onCloseModal"])
  ], 64))
}